/* eslint-ignore */
// @ts-nocheck
import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

export const ModalContainer = styled(Modal.Body)`
  background-color: #ffffff;
  border-radius: 20px;
  width: 100%;
  padding: 30px;
`;

export const ModalHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ModalLeft = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;

export const ModalTitle = styled.span`
  font-size: 1.625rem;
  color: #074f8c;
  @media (max-width: 375px) {
    font-size: 1.4375rem;
  }
`;

export const ModalBackButton = styled.span`
  font-size: 1.25rem;
  color: #074f8c;
  margin-right: 10px;
  margin-left: -3px;
  cursor: pointer;
  @media (max-width: 375px) {
    font-size: 1.125rem;
  }
`;

export const ModalCloseIcon = styled.span`
  font-size: 1.25rem;
  margin-top: -50px;
  margin-right: -11px;
  color: #074f8c;
  cursor: pointer;
  @media (max-width: 370px) {
    font-size: 1.125rem;
  }
`;

export const ModalContent = styled.span`
  font-size: 1.125rem;
  font-weight: 400;
  color: #808495;
  @media (max-width: 385px) {
    font-size: 0.875rem;
  }
`;

export const ModalAdressItem = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ModalAdressLineContainer = styled.div``;

export const ModalAdressLine = styled.span`
  font-size: 1.0625rem;
  color: #074f8c;
  @media (max-width: 991px) {
    font-size: 0.9375rem;
  }
`;

export const ModalAdressName = styled.span`
  font-size: 1.125rem;
  color: #f0b01b;
  @media (max-width: 991px) {
    font-size: 1rem;
  }
`;

export const ModalAdressIcon = styled.span`
  font-size: 1.5625rem;
  color: #f0b01b;
  margin-right: 5px;
  @media (max-width: 991px) {
    font-size: 1.25rem;
  }
`;

export const ModalAdressNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ModalSelect = styled.input`
  margin-right: 30px;
  margin-left: 20px;
  @media (max-width: 991px) {
    margin-right: 20px;
    margin-left: 5px;
  }
`;

export const ModalAdressInfoContainer = styled.div``;

export const ModalHr = styled.hr`
  width: 100%;
  height: 0.5px;
  color: #808495;
  margin-top: 20px;
`;

export const ModalAdressTitleIcon = styled.span`
  font-size: 1.4375rem;
  color: #ffffff;
  margin-bottom: -20px;
  margin-right: 15px;
`;

export const ModalAddressList = styled.div`
  padding: 40px 0px 0px 0px;
`;
